import DynamicColorRowHtml       from '../../app-lite/grids/templates/row.dynamic-color.html';
import MechanicAssignHtml        from '../mechanics/templates/mechanic.assign.html';
import MechanicLookupCellHtml    from '../mechanics/templates/mechanic.lookup.cell.html';
import MechanicSearchCellHtml    from '../mechanics/templates/mechanic-search.cell.html';
import MechanicSearchResultsHtml from '../mechanics/templates/mechanic.search.results.html';
import RemoveRowCellHtml         from '../../app-lite/grids/templates/cell.remove-row.html';
import TextareaCellHtml          from '../../app-lite/grids/templates/cell.textarea.html';
import TimeCellHtml              from '../../app-lite/grids/templates/cell.time.html';
import TimePickerCellHtml        from '../../app-lite/grids/templates/cell.time-picker.html';


export function LaborItemsCtrl (
  $q,
  $rootScope,
  $state,
  $scope,
  $translate,
  $uibModal,
  currencyApi,
  dateParsing,
  gridAPI,
  invoice_item,
  invoice,
  messages,
  streamSearch,
  workshopAPI
) {

  $scope.mechanicSearchResultsTemplateUrl = MechanicSearchResultsHtml;

  $scope.editable       = invoice ? invoice.invoice_status === 'O': true;
  $scope.currency       = currencyApi.getInfo();
  $scope.itemsToDelete  = [];
  $scope.loaded         = true;

  $scope.invoice      = invoice;
  $scope.invoice_item = invoice_item || {
    labor_items_attributes: []
  };

  $scope.grid = {
    data                   : 'invoice_item.labor_items_attributes',
    rowHeight              : 43,
    enableCellSelection    : true,
    enableRowSelection     : false,
    enableCellEditOnFocus  : true,
    sortInfo               : { fields: [], columns: [], directions: [] },
    useExternalSorting     : true,
    cellEditableCondition  : 'editable',
    virtualizationThreshold: 9999,
    rowTemplate            : DynamicColorRowHtml,
    selectedItems          : $scope.currentRow,
    columnDefs             : [
      {
        enableCellEdit: false,
        cellTemplate: RemoveRowCellHtml,
        disabled    : !$scope.editable,
        width       : '52px'
      },
      {
        enableCellEdit: false,
        cellTemplate  : MechanicLookupCellHtml,
        disabled      : !$scope.editable,
        width         : '45px'
      },
      {
        displayName: $translate.instant('EMPLOYEE_SPACE.EMPLOYEE', {
          title: $rootScope.Company.labels.employeeTitle
        }),
        field               : 'mechanic_name',
        editableCellTemplate: MechanicSearchCellHtml
      },
      {
        field               : 'note',
        displayName         : $translate.instant('GENERAL_SPACE.FIELD.NOTE'),
        cellClass           : 'pull-left',
        editableCellTemplate: TextareaCellHtml
      },
      {
        enableCellEdit: false,
        cellTemplate  : TimePickerCellHtml,
        mapTo         : 'begin_time',
        width         : '43px'
      },
      {
        field               : 'begin_time',
        displayName         : $translate.instant('JS_SPACE.COLUMNS.BEGIN_TIME'),
        cellClass           : 'Uppercase',
        cellFilter          : 'date:"dd/MM/yy hh:mm a"',
        editableCellTemplate: TimeCellHtml,
        width               : '170px'
      },
      {
        enableCellEdit: false,
        cellTemplate  : TimePickerCellHtml,
        mapTo         : 'end_time',
        width         : '43px'
      },
      {
        field               : 'end_time',
        displayName         : $translate.instant('BOOKING_SPACE.END_TIME'),
        cellClass           : 'Uppercase',
        cellFilter          : 'date:"dd/MM/yy hh:mm a"',
        editableCellTemplate: TimeCellHtml,
        width               : '170px'
      }
    ]
  };

  $scope.$watch('grid.sortInfo', function (newVal, oldVal) {
    if (newVal.fields[0]) {
      $scope.invoice_item.labor_items_attributes.sort(dynamicSort(newVal.fields[0], newVal.directions[0]));
    }
  }, true);

  function dynamicSort (property, dir) {
    return function (a,b) {
      if(dir === 'asc'){
        return b[property].toString().localeCompare(a[property]);
      }else{
        return a[property].toString().localeCompare(b[property]);
      }
    };
  }

  $scope.getRowColor = function (item, column) {
    const classes = gridAPI.getColumnClasses(column);

    if (!$scope.editable) {
      classes.push('readonly');
    }

    return classes;
  };

  $scope.addItem = function() {
    $scope.invoice_item.labor_items_attributes.push({
      id             : '',
      mechanic_id    : '',
      invoice_item_id: '',
      mechanic_name  : '',
      begin_time     : '',
      end_time       : '',
      note           : '',
      untouched      : true
    });
  };

  $scope.removeItem = function (row) {
    if (!$scope.editable) {
      return;
    }

    var deletedItem = $scope.invoice_item.labor_items_attributes.splice(row.rowIndex, 1);

    if ($scope.invoice_item.id && row.entity.id) {
      deletedItem[0]._destroy = '1';
      $scope.itemsToDelete = $scope.itemsToDelete.concat(deletedItem);
    }
  };

  $scope.addFlags = function() {
    angular.forEach($scope.invoice_item.labor_items_attributes, function(labor_item){
      labor_item.untouched = false;
    });
  };

  $scope.mechanicSearch = {
    list  : [],
    search: function (typed) {
      var _this = this;

      return streamSearch.search('mechanics', typed).then(function (mechanics) {
        return _this.list.concat(mechanics);
      });
    },
    format: function (mechanic) {
      return angular.isObject(mechanic) ? mechanic.display_name : mechanic;
    },
    choose: function (mechanic, row) {
      row.entity.mechanic_id = mechanic.id;
      row.entity.mechanic_name = mechanic.display_name;
      row.entity.untouched = false;
    }
  };

  $scope.assignMechanic = function(e, row) {
    $uibModal.open({
      windowClass: 'lg-modal',
      templateUrl: MechanicAssignHtml,
      controller : 'mechanicLookupCtrl',
      resolve    : {
        mechanics: ['workshopAPI', function (workshopAPI) {
          return workshopAPI.get('/mechanics', ['*', '*', 'display_name', 'asc']);
        }]
      }
    }).result.then(function (mechanic) {
      $scope.invoice_item.labor_items_attributes[row.rowIndex].mechanic_name = mechanic.display_name;
      $scope.invoice_item.labor_items_attributes[row.rowIndex].mechanic_id = mechanic.id;
      $scope.invoice_item.labor_items_attributes[row.rowIndex].untouched = false;
    });
  };

  $scope.openPicker = function(row, column, event) {
    var picker = $(event.currentTarget).datetimepicker({
      showMeridian: true,
      startView   : 'day',
      initialDate : row.entity[column.colDef.mapTo] ? new Date(row.entity[column.colDef.mapTo]): dateParsing.today()
    }).on('changeDate', function(ev){
      // This datetime picker has a bug that returns UTC date instead of what was selected
      // so we need to convert it
      var date = new Date(ev.date.valueOf());
      var year = date.getUTCFullYear();
      var month = date.getUTCMonth();
      var day = date.getUTCDate();
      var hour = date.getUTCHours();
      var min = date.getUTCMinutes();
      var ISODate = new Date(year, month, day, hour, min);
      var iso = ISODate.toISOString();

      $scope.invoice_item.labor_items_attributes[row.rowIndex][column.colDef.mapTo] = ISODate;

      if (!$scope.$$phase) {
        $scope.$apply();
      }

      $(picker).datetimepicker('hide');
    });
    $(picker).datetimepicker('show');
  };

  $scope.deleteItems = function () {
    var deferred = $q.defer();
    var invoice_item = {
      id                    : $scope.invoice_item.id,
      labor_items_attributes: $scope.itemsToDelete
    };

    if ($scope.itemsToDelete.length && $scope.invoice_item.id) {
      workshopAPI.patch('/invoice_item', invoice_item, 'invoice_item')
      .then(function (invoice_item) {
        deferred.resolve(invoice_item);
      }, function (err) {
        deferred.reject(err);
      });
    }
    else {
      deferred.resolve();
    }

    return deferred.promise;
  };

  $scope.save = function () {
    var deferred = $q.defer();

    if ($scope.form.$invalid) {
      messages.clientError($scope.form);
      deferred.reject();
    }

    $scope.deleteItems().then(function () {
      workshopAPI.patch('/invoice_item', $scope.invoice_item, 'invoice_item', 'labor_items_attributes')
      .then(function (item) {
        $scope.form.$setPristine();
        $state.go('app.labor-items', {
          invoice_id: $scope.invoice.id,
          id        : item.id
        });
        deferred.resolve(item);
      }, function (err) {
        deferred.reject(err);
      });
    }, function (err) {
      deferred.reject(err);
    });

    return deferred.promise;
  };

  $scope.submit = function () {
    $scope.save().then(function (invoice) {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.LABOUR_ITEMS'), 'success');
      $state.reload();
    }, function (err) {
      messages.error(err);
    });
  };

  if (invoice_item) {
    $scope.addFlags();
  }

  $scope.$watch('invoice_item.labor_items_attributes.length', function (length) {
    if (!length) {
      $scope.addItem();
    }
  });

}